import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import Amplify from 'aws-amplify';

import 'hammerjs';

Amplify.configure(environment.amplify.config);
if (environment.amplify.logLevel)
  Amplify.Logger.LOG_LEVEL = environment.amplify.logLevel;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));


